<template>
  <div>

    <header class="bg-theme fixed w-full z-40 shadow-md max-h-screen">
      <div class="container-fluid py-3 flex items-center">
        <div class="w-2/12">
          <router-link to="/">
            <span class="hidden md:block">
              <img class="h-10" :src="!config.logoPath || url.resolve(config.URL.API.host, config.logoPath)" alt="logo">
            </span>
            <span class="sm:block md:hidden">
              <img class="h-8" :src="!config.logoSmallPath || url.resolve(config.URL.API.host, config.logoSmallPath)" alt="logo">
            </span>
          </router-link>
        </div>
        <div class="w-10/12 flex flex-wrap justify-end items-center">
          <a
            class="text-xs px-2 mr-1 cursor-pointer"
            @click="$router.push('/changelog')"
          >
            <i class="fas fa-exclamation fa-xs text-red-500" v-if="hasNewChangelog"></i>
            <span class="ml-1">Changelog</span>
          </a>

          <a class="lg:hidden cursor-pointer py-1 px-2" @click="toggleMobileMenu">
            <i class="fas fa-bars text-theme-lighter"></i>
          </a>

          <nav class="nav nav-user z-40">
            <ul class="root text-theme">
              <li class="has-submenu">
                <a class="cursor-pointer">
                  <i class="far fa-user-circle"></i>
                  <span class="hidden sm:inline">
                    <span class="mx-2">{{ User.name }}</span>
                    <i class="fas fa-chevron-down text-xs"></i>
                  </span>
                </a>
                <ul class="sub text-xs">
                  <li class="py-2 px-4">
                    <p class="font-bold">{{ $formatMoney(defaultCashAccount.balance) }} cash</p>
                  </li>
                  <li>
                    <router-link to="/profile/details">
                      <i class="far fa-user-circle"></i>
                      <span class="ml-2">My Account</span>
                    </router-link >
                  </li>
                  <li class="py-2 px-4">
                    <button
                      type="button"
                      class="btn px-4"
                      :class="config.theme === 'light' ? 'btn-purple' : 'border border-gray-700 light:border-gray-300'"
                      @click="setTheme('light')"
                    >
                      Light
                    </button>
                    <button
                      type="button"
                      class="btn px-4 ml-2"
                      :class="config.theme === 'dark' ? 'btn-purple' : 'border border-gray-700 light:border-gray-300'"
                      @click="setTheme('dark')"
                    >
                      Dark
                    </button>
                  </li>
                  <li class="border-t border-theme-darker">
                    <a @click="logout" class="cursor-pointer">
                      <i class="fas fa-sign-out-alt"></i>
                      <span class="ml-2">Logout</span>
                    </a >
                  </li>
                </ul>
              </li>
            </ul>
          </nav>

          <div
            class="py-1 px-2 hover:text-theme-lighter"
            v-if="canViewAdministrationPages"
          >
            <router-link :to="defaultAdministrationPage">
              <i class="fas fa-cog"></i>
            </router-link>
          </div>
        </div>
      </div>

      <top-menu :class="{ 'administrator': isAdministrationRoute }"/>
    </header>

    <div
      class="bg-theme-900 opacity-90 w-full h-full fixed left-0 top-0 z-30"
      v-if="config.mobileMenuOpen"
      @click.stop="toggleMobileMenu"
    ></div>

  </div>
</template>

<script>
import url from 'url'
import { mapGetters, mapActions } from 'vuex'
const TopMenu = resolve => require(['@/components/layout/TopMenu'], resolve)

export default {
  data() {
    return {
      url,
      administrationRootPages: [
        {name: 'site-settings', defaultPage: '/administration/settings/general'},
        {name: 'financial-account', defaultPage: '/administration/financial-account/list'},
        {name: 'financial-transfer', defaultPage: '/administration/financial-account/list-transfers'},
      ],
      modal: {
        reminder: {
          active: false,
          title: 'Create reminder',
        }
      }
    }
  },
  components: {
    TopMenu,
  },
  computed: {
    hasNewChangelog() {
      return this.changelog.some(log => log.new === true)
    },
    defaultAdministrationPage() {
      return this.canViewAdministrationPages ? this.canViewAdministrationPages.defaultPage : ''
    },
    canViewAdministrationPages() {
      for (let i in this.administrationRootPages) {
        if (this.userHasPermissionRoot(this.administrationRootPages[i].name)) {
          return this.administrationRootPages[i]
        }
      }
      return false
    },
    isAdministrationRoute() {
      if (!this.$route.name) {
        return false
      }
      return this.$route.name.split('.')[0] === 'administration'
    },
    ...mapGetters({
      User: 'user/user',
      UserPermissions: 'user/permissions',
      isAdmin: 'user/isAdmin',
      config: 'config/config',
      defaultCashAccount: 'config/defaultCashAccount',
      userHasPermissionRoot: 'user/hasPermissionRoot',
      changelog: 'changelog/changelog',
    })
  },
  methods: {
    toggleMobileMenu() {
      this['config/toggleMobileMenu']()
    },
    setTheme(theme) {
      if (this.config.theme === theme) {
        return
      }
      this['config/changeTheme'](theme)
    },
    logout: function () {
      this.$store.dispatch('user/logout')
        .then(() => { this.$router.push('/login') })
    },
    ...mapActions([
      'config/changeTheme',
      'config/toggleMobileMenu',
    ])
  }
}
</script>
